module.exports = __webpack_public_path__ + "img/wordpress-icon-white.bda97fc9.svg";